var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportingMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.125 5.4375H19.1875C19.5522 5.4375 19.9019 5.58237 20.1598 5.84023C20.4176 6.09809 20.5625 6.44783 20.5625 6.8125V21.25C20.5625 21.6147 20.4176 21.9644 20.1598 22.2223C19.9019 22.4801 19.5522 22.625 19.1875 22.625H6.8125C6.44783 22.625 6.09809 22.4801 5.84023 22.2223C5.58237 21.9644 5.4375 21.6147 5.4375 21.25V6.8125C5.4375 6.44783 5.58237 6.09809 5.84023 5.84023C6.09809 5.58237 6.44783 5.4375 6.8125 5.4375H8.875V4.75C8.875 4.38533 9.01987 4.03559 9.27773 3.77773C9.53559 3.51987 9.88533 3.375 10.25 3.375H15.75C16.1147 3.375 16.4644 3.51987 16.7223 3.77773C16.9801 4.03559 17.125 4.38533 17.125 4.75V5.4375ZM15.75 4.75H10.25V7.5H15.75V4.75ZM6.8125 21.25H19.1875V6.8125H17.125V8.875H8.875V6.8125H6.8125V21.25ZM8.875 10.9375H17.125V12.3125H8.875V10.9375ZM8.875 14.375H14.375V15.75H8.875V14.375ZM12.3125 17.8125H8.875V19.1875H12.3125V17.8125Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingMenuIcon);
export default __webpack_public_path__ + "static/media/reporting-menu-icon.b84612857495f359d71416a7d016b10d.svg";
export { ForwardRef as ReactComponent };